var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 38.5,
  width: 39,
  height: 1.5,
  rx: 0.75,
  fill: "#c3ccd2"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 4,
  width: 23,
  height: 34.5,
  rx: 1.2,
  fill: "#7a6a55"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 5.6,
  width: 19.8,
  height: 31.4,
  fill: "#cfe6f2"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 14.5,
  y: 31.5,
  width: 4,
  height: 5.5,
  fill: "#9fc4d8"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 29.5,
  width: 4.5,
  height: 7.5,
  fill: "#9fc4d8"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 32.5,
  width: 4,
  height: 4.5,
  fill: "#9fc4d8"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 5.6,
  width: 19.8,
  height: 1.6,
  fill: "#7a6a55"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 7.8,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 10,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 12.2,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 14.4,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 16.6,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 18.8,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 21,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 23.2,
  width: 19.8,
  height: 1.5,
  fill: "#e8ddc8"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  x: 12.6,
  y: 25.4,
  width: 19.8,
  height: 1.8,
  fill: "#d9c9a8"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m30.5 27.2v2.6",
  fill: "none",
  stroke: "#7a6a55",
  strokeWidth: 0.8
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  cx: 30.5,
  cy: 30.4,
  r: 0.7,
  fill: "#7a6a55"
});

function SvgWindowShades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowShades);
export default __webpack_public_path__ + "static/media/window-shades.91b81d1f35c916ac9da9d763c550633c.svg";
export { ForwardRef as ReactComponent };